// extracted by mini-css-extract-plugin
module.exports = {"zodiacWrapper":"Partner_zodiacWrapper__2bzDy","formWrapper":"Partner_formWrapper__0jCOu","buttonWrapper":"Partner_buttonWrapper__r_Ycp"};